import React from 'react';
import { connect } from "react-redux";
import {setMeasurementVisibleInSlabMode} from "../../../../../actions/sqftSlabFunctions";

const ShowMeasurementsInTheSlabModeButton = (props) => {
  const {isMeasurementVisibleInSlabMode, setMeasurementVisibleInSlabMode} = props;

  const handleButtonClick = () => {
    setMeasurementVisibleInSlabMode(!isMeasurementVisibleInSlabMode);
  };

  return (
    <div className="ui-button-block">
      <button className={"button--rounded button--guides-white " + (isMeasurementVisibleInSlabMode ? "button-active" : "")}
              onClick={handleButtonClick}>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => ({
  isMeasurementVisibleInSlabMode: store.sqftSlabState.isMeasurementVisibleInSlabMode,
});

const mapDispatchToProps = {
  setMeasurementVisibleInSlabMode
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMeasurementsInTheSlabModeButton);
